import React from 'react';
import { Button, Text } from '@fluentui/react-components';
import { WeatherMoon24Regular } from '@fluentui/react-icons';
import { Box, useFluentTokens } from '../../../../theme/fluent';
import { useAppLayoutStyles } from '../../AppLayout.styles';

type NavigationFooterProps = {
    isCollapsed: boolean;
}

export const NavigationFooter: React.FC<NavigationFooterProps> = ({ isCollapsed }) => {
    const { tokens, modeTokens, mode, toggleTheme } = useFluentTokens();
    const { classes, pureWhiteColor } = useAppLayoutStyles();

    return (
        <Box>
            {/* Dark mode toggle - only shown when expanded */}
            {!isCollapsed && (
                <Box className={classes.themeToggleRoot}>
                    <Box className={classes.themeToggleIconWrapper}>
                        <WeatherMoon24Regular className={classes.themeToggleIcon} style={pureWhiteColor} />
                    </Box>

                    <Box className={classes.themeToggleItem}>
                        <Text size={300} className={classes.themeToggleItemText} style={pureWhiteColor}>
                            Dark mode
                        </Text>
                        <Button
                            appearance="subtle"
                            size="small"
                            onClick={toggleTheme}
                            aria-label={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
                            aria-pressed={mode === 'dark'}
                            className={classes.themeToggleButton}
                            style={{
                                minWidth: '40px',
                                height: '24px',
                                padding: '2px',
                                borderRadius: '12px',
                                position: 'relative',
                                backgroundColor: mode === 'dark'
                                    ? modeTokens.colorNeutralForegroundStaticInverted
                                    : 'transparent',
                                border:
                                    mode === 'dark'
                                        ? 'none'
                                        : `2px solid ${modeTokens.colorNeutralForegroundStaticInverted}`,
                            }}
                        >
                            <Box
                                style={{
                                    width: '16px',
                                    height: '16px',
                                    borderRadius: '50%',
                                    backgroundColor:
                                        mode === 'dark' ? '#242424' : modeTokens.colorNeutralForegroundStaticInverted,
                                    position: 'absolute',
                                    left: mode === 'dark' ? 'calc(100% - 20px)' : '2px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    transition: 'left 0.2s ease',
                                }}
                            />
                        </Button>
                    </Box>
                </Box>
            )}

            <Box className={classes.collapseSeparator} />

            {/* Powered By Section */}
            <Box
                className={classes.powerSection}
                style={{
                    gap: isCollapsed ? '0' : tokens.spacingVerticalM,
                    padding: `0 ${tokens.spacingVerticalL}`,
                }}
            >
                <Text size={200} className={classes.powerSectionText}>
                    {isCollapsed ? 'AI-CoE' : 'Powered by ITS AI-CoE'}
                </Text>
            </Box>
        </Box>
    );
};
